<script>
    import { screenStore } from "../../functions/stores";
    import blogList from "./blogLists.json";
    import { onMount } from "svelte";
    export let itemSelected = {};
    onMount((e) => {
        itemSelected = { item: blogList[0], i: 0 };
    });
</script>

{#if $screenStore.width < 700}
    <div class=" pb-10 md:px-32 flex justify-center">
        <div class="w-1/2 space-x-5 pt-10 flex justify-evenly">
            {#each blogList as blog, i}
                <div
                    style="cursor: pointer;"
                    on:keypress     
                    on:click={() => {
                        itemSelected = { item: blog, i };
                    }}
                    class={itemSelected.item?.title == blog.title
                        ? "text-slate-700 hover-underline-animation font-bold"
                        : "text-slate-400 hover-underline-animation"}
                >
                    {blog.subTitle}
                </div>
            {/each}
        </div>
    </div>
{/if}
<div class="flex md:justify-evenly md:py-10">
    {#if $screenStore.width > 700}
        <div class=" pb-10 md:px-32">
            <div class="space-y-10">
                {#each blogList as blog, i}
                    <div
                        style="cursor: pointer;"
                        on:keypress
                        on:click={() => {
                            itemSelected = { item: blog, i };
                        }}
                        class={itemSelected.item?.title == blog.title
                            ? "text-slate-700 hover-underline-animation font-bold"
                            : "text-slate-400 hover-underline-animation"}
                    >
                        {blog.subTitle}
                    </div>
                {/each}
            </div>
        </div>
    {/if}

    <div class="px-5 md:w-1/2 pb-10">
        <div class="pb-10 text-3xl font-bold">
            {itemSelected?.item?.title}
        </div>
        {itemSelected?.item?.blog}
    </div>
</div>

<style>
    .hover-underline-animation {
        position: relative;
    }

    .hover-underline-animation::after {
        content: "";
        position: absolute;
        width: 50%;
        transform: scaleX(0);
        height: 2px;
        top: 25px;
        left: 0%;
        background-color: #3e0cd671;
        transform-origin: bottom right;
        transition: transform 0.35s ease-out;
    }

    .hover-underline-animation:hover::after {
        transform: scaleX(1);
        transform-origin: bottom left;
    }
</style>
